import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_CAMPUS_API_BASE_URL || 'https://campus-dev.duckdns.org/gateway';

// API 클라이언트 설정
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 응답 타입 정의
interface AllowedValuesResponse {
  code: number;
  status: string;
  message: string;
  data: string[];
}

// 허용된 값들 조회 (학교 또는 부서)
export const getAllowedValues = async (identity: 'STUDENT' | 'DOCTOR'): Promise<string[]> => {
  try {
    const response = await apiClient.get<AllowedValuesResponse>(
      `/api/persons/allowed-values/list`,
      {
        params: { identity }
      }
    );
    
    if (response.data.code === 200) {
      return response.data.data || [];
    } else {
      /// console.warn('API 응답 코드가 200이 아닙니다:', response.data);
      return [];
    }
  } catch (error) {
    /// console.error(`${identity} 목록 조회 실패:`, error);
    return [];
  }
};

// 학교 목록 조회 (학생용)
export const getUniversities = async (): Promise<string[]> => {
  return getAllowedValues('STUDENT');
};

// 부서/진료과 목록 조회 (의사용)
export const getDepartments = async (): Promise<string[]> => {
  return getAllowedValues('DOCTOR');
};
